import { Field, ID, ObjectType } from 'type-graphql'
import {
  Column,
  CreateDateColumn,
  Entity,
  Index,
  JoinTable,
  ManyToMany,
  ManyToOne,
  PrimaryGeneratedColumn,
  RelationId,
  UpdateDateColumn
} from 'typeorm'

import { User } from '@things-factory/auth-base'
import { Domain, ScalarObject } from '@things-factory/shell'

import { Board } from '../board/board.js'

@Entity()
@Index('ix_play_group_0', (playGroup: PlayGroup) => [playGroup.domain, playGroup.name], { unique: true })
@ObjectType({ description: 'A group of boards that can be played in a sequence or collection.' })
export class PlayGroup {
  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID, { description: 'Unique identifier for the play group.' })
  readonly id: string

  @ManyToOne(type => Domain)
  @Field(type => Domain, { nullable: true, description: 'The domain to which this play group belongs.' })
  domain?: Domain

  @RelationId((playGroup: PlayGroup) => playGroup.domain)
  domainId?: string

  @Column()
  @Field({ description: 'The name of the play group.' })
  name: string

  @Column({
    nullable: true
  })
  @Field({ nullable: true, description: 'A detailed description of the play group.' })
  description?: string

  @ManyToMany(type => Board, board => board.playGroups)
  @JoinTable({ name: 'play_groups_boards' })
  @Field(type => [Board], { nullable: true, description: 'The list of boards included in this play group.' })
  boards: Board[]

  @Column('simple-json', { nullable: true })
  @Field(type => [String], {
    nullable: true,
    description: 'An array of board IDs, defining the specific playback order of boards within the group.'
  })
  order?: string[]

  @CreateDateColumn()
  @Field({ nullable: true, description: 'The timestamp when the play group was created.' })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true, description: 'The timestamp when the play group was last updated.' })
  updatedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true, description: 'The user who created the play group.' })
  creator?: User

  @RelationId((playGroup: PlayGroup) => playGroup.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true, description: 'The user who last updated the play group.' })
  updater?: User

  @RelationId((playGroup: PlayGroup) => playGroup.updater)
  updaterId?: string
}
